export const invetarioModel = {
  su: null,
  ns: null,
  mt: null,
  nm: null,
  cm: null,
  um: null,
  pv: null,
  tm: null,
  mg: null,
  ct: null,
  dt: null,
  sx: null,
  sd: null,
  si: null,
  fc: null,
  te: null,
  pr: null,
  np: null,
  md: null,
  mc: null,
  ud: null,
  cc: 0,
  co: null,
  cd: null,
  st: false,
  al: null,
  nl: null,
  lts: [],
};

export const LoteInventarioModel = {
  lt: null,
  al: null,
  na: null,
  oc: null,
  cc: null,
  fi: null,
  sd: 0,
  pc: 0.0,
  st: false,
};
